import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HiOutlineMenuAlt3, HiX, HiArrowRight } from 'react-icons/hi';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from '../common/Logo';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Careers', path: '/career' },
    { name: 'Contact', path: '/contact' },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    localStorage.removeItem('condition');
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'py-3 bg-white/80 backdrop-blur-xl border-b border-hairline shadow-soft'
          : 'py-5 bg-white/60 backdrop-blur-md'
      }`}
    >
      <div className="container-custom flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Logo size="md" withText={true} />
        </div>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.name}
                to={link.path}
                className="group relative text-sm font-medium text-ink hover:text-nexcess-blue transition-colors"
              >
                <span>{link.name}</span>
                <span
                  className={`absolute -bottom-1.5 left-0 h-0.5 rounded-full bg-gradient-to-r from-nexcess-blue to-nexcess-purple transition-all duration-300 ${
                    active ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                />
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <button
            onClick={() => navigate('/contact')}
            className="btn btn-primary"
          >
            Get Started <HiArrowRight />
          </button>
        </div>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="lg:hidden p-2 text-ink hover:text-nexcess-blue transition-colors rounded-lg"
          aria-label="Toggle menu"
        >
          {isOpen ? <HiX size={24} /> : <HiOutlineMenuAlt3 size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-hairline shadow-soft"
          >
            <div className="container-custom py-6 flex flex-col">
              <ul className="flex flex-col divide-y divide-hairline">
                {navLinks.map((link) => {
                  const active = location.pathname === link.path;
                  return (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className={`flex items-center justify-between py-4 text-lg font-semibold transition-colors ${
                          active ? 'text-nexcess-blue' : 'text-ink hover:text-nexcess-blue'
                        }`}
                      >
                        <span>{link.name}</span>
                        <HiArrowRight className="text-ink-soft" />
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <button
                onClick={() => {
                  navigate('/contact');
                  setIsOpen(false);
                }}
                className="btn btn-primary mt-3 w-full"
              >
                Get Started <HiArrowRight />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
